import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Suspense, lazy } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { useAppTranslator } from "@plansoft-configuration-renderer/localization";
const MissingKeysTable = lazy(() => import("./MissingKeysTable"));
export function SaveMissingKeysDialog(props) {
    const t = useAppTranslator();
    const { isOpen, onClose, dataManagerBasePath, uploadAllowed } = props;
    const title = t("ConfigurationRenderer:SaveMissingKeysDialog.title", "Save missing keys");
    const textClose = t("ConfigurationRenderer:SaveMissingKeysDialog.close", "Close");
    return (_jsxs(Dialog, { onClose: onClose, open: isOpen, maxWidth: "lg", fullWidth: true, children: [_jsx(DialogTitle, { children: title }), _jsx(DialogContent, { children: _jsx(Suspense, { children: isOpen && (_jsx(MissingKeysTable, { dataManagerBasePath: dataManagerBasePath, uploadAllowed: uploadAllowed })) }) }), _jsx(DialogActions, { children: _jsx(Button, { onClick: onClose, children: textClose }) })] }));
}
//# sourceMappingURL=SaveMissingKeysDialog.js.map